import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles, Card, CardActions, CardContent } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import moment from 'moment';

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    modalTitle: {
        marginTop: '20px',
        marginBottom: '20px',
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    buttonsRow: {
        marginTop: '20px',
        marginBottom: '20px',
        textAlign: 'center'
    },
    buttonSubmit: {
        marginTop: '20px'
    }
});


class IniciarTransmissao extends Component {
    constructor(props) {
        super(props);
        const { sessionId, streamUrl, streamKey } = props;

        this.state = {
            sessionId,
            streamUrl: streamUrl ? streamUrl : '',
            streamKey: streamKey ? streamKey : ''
        }
    }

    render() {
        const { classes, handleModalClose } = this.props;
        const { streamUrl, streamKey } = this.state;

        return (
            <Paper className={classes.root}>
                <Container style={{minWidth: 500}}>
                    <Row>
                        <Col className={classes.headerWrapper}>
                            <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Typography variant="h5" className={classes.modalTitle}>Iniciar a transmissão</Typography>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label htmlFor="input-stream-url">URL RTMP</label>
                            <Form.Control id="input-stream-url" value={streamUrl} onChange={(a) => this.setState({streamUrl: a.target.value})}/>
                        </Col>
                    </Row>
                    <Row  style={{marginTop: '25px'}}>
                        <Col>
                            <label htmlFor="input-stream-key">Stream / chave:</label>
                            <Form.Control id="input-stream-key" value={streamKey} onChange={(a) => this.setState({streamKey: a.target.value})}/>
                        </Col>
                    </Row>
                    <Row>
                        <Col style={{textAlign: "center", marginTop: '50px'}}>
                            <Button style={{width: "40%"}} variant="green" type="submit" onClick={() => {  this.handleSaveData(true) }} className={classes.buttonSubmit}>Salvar</Button>&nbsp;&nbsp;
                            <Button style={{width: "40%"}} variant="green" type="submit" onClick={() => {  this.handleSaveData(false) }} className={classes.buttonSubmit}>Salvar e Iniciar</Button>
                        </Col>
                    </Row>
                </Container>
            </Paper>
        )
    }

    handleSaveData(skipStart) {
        const { handleModalSaveChange } = this.props;
        const { sessionId, streamUrl, streamKey } = this.state;

        handleModalSaveChange(sessionId, streamUrl, streamKey, skipStart );
    }

}

export default withStyles(classes)(IniciarTransmissao);